import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// icons
import { AiOutlineMail } from 'react-icons/ai';
import { MdOutlinePrivacyTip } from 'react-icons/md';
import { SocialIcon } from 'react-social-icons';

// navigation
import Nav from 'react-bootstrap/Nav';

// utils
import { Colors } from '../../../styles'

const Footer = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <Row className='mt-5'>

            <div className='mt-5'>
                <hr />
            </div>

            <div style={{ display:'flex', justifyContent:'space-between'}}>
                { props.small ? <div /> :
                <div className='mt-2'>
                    <div style={{display:'flex', cursor:'pointer'}}>
                        <AiOutlineMail size={18} style={{marginTop:3}} color={'#307FE2'} />
                        <p style={{ marginLeft:4, fontSize:16, color:Colors.PRM_LIGHT_BLUE}}>
                            <a href={'https://prmassist.com/contact'} style={{color:Colors.PRM_LIGHT_BLUE}}>Contact us</a>
                        </p>
                    </div>
                    <div style={{display:'flex', cursor:'pointer'}}>
                        {/*
                        <MdOutlinePrivacyTip size={18} style={{marginTop:3}} color={'#307FE2'} />
                        <p style={{ marginLeft:4, fontSize:16, color:Colors.PRM_LIGHT_BLUE, textDecoration:'underline' }}>
                            <Nav.Link href="/privacy-policy">Privacy Policy</Nav.Link>
                        </p>*/}
                    </div>
                </div>
                }
                <div>
                    { props.small ? null : 
                    <Row style={{maxWidth:300}}>
                        <Col><SocialIcon url="https://twitter.com/PrmAssist" /></Col>
                        <Col><SocialIcon url="https://www.linkedin.com/company/prmassist/" /></Col>
                        <Col><SocialIcon url="https://www.facebook.com/prmassist" /></Col>
                    </Row>
                    }
                    <p style={{marginTop:12, opacity:0.6}}>© 2022 Copyright: PRM Assist</p>
                </div>
            </div>
        </Row>
    );
};

export default Footer;